import React, { useState } from 'react';
import styled from 'styled-components';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';
import { InteractionType } from 'types/api';
import TitleContainer from '../../TitleContainer';

const SelectOnlineWay = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px;

  width: 100%;

  border-radius: 12px;
  border: ${props =>
    props.$isSelected ? '1.5px solid #1b1c1e' : '1px solid #dbdcdf'};
  background: ${props => (props.$isSelected ? '#f7f7f8' : '#fff')};

  color: #1b1c1e;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.6px;
  cursor: pointer;
`;

const RadioBox = styled.input`
  width: 24px;
  height: 24px;
  appearance: none;
  border: 3px solid #eee;
  border-radius: 50%;
  cursor: pointer;

  &:checked {
    border: 8px solid #1b1c1e;
  }
`;

interface OnlineSelectFormIProps {
  isMobile: boolean;
  productParamInput: ProductParamInput;
  handleOnChangeProductParamInput: (key: string, value: any) => void;
}

const OnlineSelectForm: React.FC<OnlineSelectFormIProps> = props => {
  const { isMobile, productParamInput, handleOnChangeProductParamInput } =
    props;

  const handleChangeOnlineForm = (interactionType: InteractionType) => {
    handleOnChangeProductParamInput('frip', {
      ...productParamInput.frip,
      interactionType,
    });
  };

  const renderForm = (): JSX.Element => {
    return (
      <Column gap="12px">
        <SelectOnlineWay
          $isSelected={
            productParamInput.frip.interactionType ===
            InteractionType.VIDEO_CHAT
          }
          onClick={() => handleChangeOnlineForm(InteractionType.VIDEO_CHAT)}
        >
          화상 채팅
          <RadioBox
            type="radio"
            checked={
              productParamInput.frip.interactionType ===
              InteractionType.VIDEO_CHAT
            }
            onChange={() => handleChangeOnlineForm(InteractionType.VIDEO_CHAT)}
          />
        </SelectOnlineWay>
        <SelectOnlineWay
          $isSelected={
            productParamInput.frip.interactionType ===
            InteractionType.PHONE_CALL
          }
          onClick={() => handleChangeOnlineForm(InteractionType.PHONE_CALL)}
        >
          전화
          <RadioBox
            type="radio"
            checked={
              productParamInput.frip.interactionType ===
              InteractionType.PHONE_CALL
            }
            onChange={() => handleChangeOnlineForm(InteractionType.PHONE_CALL)}
          />
        </SelectOnlineWay>
        <SelectOnlineWay
          $isSelected={
            productParamInput.frip.interactionType === InteractionType.VIDEO
          }
          onClick={() => handleChangeOnlineForm(InteractionType.VIDEO)}
        >
          영상 제공
          <RadioBox
            type="radio"
            checked={
              productParamInput.frip.interactionType === InteractionType.VIDEO
            }
            onChange={() => handleChangeOnlineForm(InteractionType.VIDEO)}
          />
        </SelectOnlineWay>
        <SelectOnlineWay
          $isSelected={
            productParamInput.frip.interactionType ===
            InteractionType.CHATTING_GUIDE
          }
          onClick={() => handleChangeOnlineForm(InteractionType.CHATTING_GUIDE)}
        >
          채팅을 통한 별도 안내
          <RadioBox
            type="radio"
            checked={
              productParamInput.frip.interactionType ===
              InteractionType.CHATTING_GUIDE
            }
            onChange={() =>
              handleChangeOnlineForm(InteractionType.CHATTING_GUIDE)
            }
          />
        </SelectOnlineWay>
      </Column>
    );
  };

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <Column gap="32px" align="flex-start">
          {renderForm()}
        </Column>
      );
    }

    return <Column>{renderForm()}</Column>;
  };

  return renderContents();
};

export default OnlineSelectForm;
